import { Stack } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardEventSection } from "web_myplann/Dashboard/Components/DashboardEventSection";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { DASHBOARD_PREVIEW_LIMIT } from "web_myplann/Dashboard/constants";
import { useDashboardActivities } from "web_myplann/Dashboard/Hooks/useDashboardActivities";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Dashboard.Sections;

export const DashboardActivitySections: FC = () => {
	const { t } = useResource();
	const navigate = useNavigate();

	const { solvedEvents, upcomingEvents, overdueEvents, isLoading } =
		useDashboardActivities(DASHBOARD_PREVIEW_LIMIT);

	if (isLoading) {
		return (
			<Stack px={1.6}>
				<DashboardSkeleton height={150} />
			</Stack>
		);
	}

	const showAll = () => navigate(Routing.ActivitiesList.path());

	return (
		<>
			<DashboardEventSection
				title={t(R.todo)}
				items={solvedEvents.items}
				onShowAll={showAll}
			/>
			<DashboardEventSection
				title={t(R.upcoming)}
				items={upcomingEvents.items}
				onShowAll={showAll}
			/>
			<DashboardEventSection
				title={t(R.past)}
				items={overdueEvents.items}
				onShowAll={showAll}
			/>
		</>
	);
};
